export { default as AccordionBlock } from './module-accordion.jsx';
export { default as AutomatedStaffCarouselBlock } from './module-automated-staff-carousel.jsx';
export { default as ContactDetailsBlock } from './module-contact-details.jsx';
export { default as ContactLinksBlock } from './module-contact-links.jsx';
export { default as FeaturedArticlesCarouselBlock } from './module-featured-articles-carousel.jsx';
export { default as FeaturedPropertiesBlock } from './module-featured-properties.jsx';
export { default as FeaturedPropertiesCarouselBlock } from './module-featured-properties-carousel.jsx';
export { default as FeaturedStaffCarouselBlock } from './module-featured-staff-carousel.jsx';
export { default as FeaturedTaxonomyBlock } from './module-featured-taxonomy.jsx';
export { default as FourImagesBlock } from './module-four-images.jsx';
export { default as HeaderLinks } from './module-header-links.jsx';
export { default as HighlightsCarousel } from './module-highlights-carousel.jsx';
export { default as ImageBlock } from './module-image.jsx';
export { default as ImageCarouselBlock } from './module-image-carousel.jsx';
export { default as InListingBlock } from './module-in-listing.jsx';
export { default as KeyLinksBlock } from './module-key-links.jsx';
export { default as LargeImageBlock } from './module-large-image.jsx';
export { default as LetPropertiesCarousel } from './module-let-properties-carousel.jsx';
export { default as OffMarketFormBlock } from './module-off-market-form.jsx';
export { default as OffMarketBannerBlock } from './module-off-market-banner.jsx';
export { default as ShortLetPropertiesCarousel } from './module-short-let-properties-carousel.jsx';
export { default as OfficesBlock } from './module-offices.jsx';
export { default as PartnershipFeaturedPropertiesBlock } from './module-partnership-featured-properties.jsx';
export { default as PartnershipFeaturedPropertiesCarouselBlock } from './module-partnership-featured-properties-carousel.jsx';
export { default as QuoteBlock } from './module-quote.jsx';
export { default as RelatedPropertiesCarousel } from './module-related-properties-carousel.jsx';
export { default as RelatedRentalPropertiesCarousel } from './module-related-rental-properties-carousel.jsx';
export { default as SectionBlock } from './module-section.jsx';
export { default as SoldPropertiesCarousel } from './module-sold-properties-carousel.jsx';
export { default as StampDutyCalculatorBlock } from './module-stamp-duty-calculator.jsx';
export { default as TeamBlock } from './module-team.jsx';
export { default as ThreeImagesBlock } from './module-three-images.jsx';
export { default as TwoImagesBlock } from './module-two-images.jsx';
export { default as TwoImagesLandscapeBlock } from './module-two-images-landscape.jsx';
export { default as TwoImagesV2Block } from './module-two-images-v2.jsx';
export { default as ValuationLinksBlock } from './module-valuation-links.jsx';
export { default as VideoBlock } from './module-video.jsx';

// Brochure modules
export { default as BrochureImageBlock } from './module-brochure-image.jsx';
export { default as BrochureSectionBlock } from './module-brochure-section.jsx';
